import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const getCompanyCandidates = ({ companyId }, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/get_candidates",
      method: "GET",
      params: { companyId },
    },
    opts,
  );

export const suggestCompanies = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/suggest",
      method: "POST",
      body,
    },
    opts,
  );

export const queryCompanies = (body = {}, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/query",
      method: "POST",
      body,
    },
    opts,
  );

export const createCompany = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/create",
      method: "POST",
      body,
    },
    opts,
  );

export const deleteCompany = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/delete",
      method: "POST",
      body,
    },
    opts,
  );

export const getCompany = ({ companyId }, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/get",
      method: "GET",
      params: { companyId },
    },
    opts,
  );

export const updateCompany = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/update",
      method: "POST",
      body,
    },
    opts,
  );

export const updateCompanyLocations = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/location",
      method: "POST",
      body,
    },
    opts,
  );

export const mergeCompanies = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/companies/merge",
      method: "POST",
      body,
    },
    opts,
  );
